import { render } from "./FormAccountComponent.vue?vue&type=template&id=5517474f"
import script from "./FormAccountComponent.vue?vue&type=script&lang=js"
export * from "./FormAccountComponent.vue?vue&type=script&lang=js"

import "./FormAccountComponent.vue?vue&type=style&index=0&id=5517474f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__